<div
    class="landing-background tw-fixed tw-top-0 tw-left-0 tw-z-50 tw-flex tw-h-screen tw-w-screen tw-flex-col tw-overflow-hidden tw-bg-white">
    <div
        class="tw-flex tw-h-16 tw-items-center tw-justify-between tw-bg-white tw-py-2 tw-px-6">
        <div>
            <img
                width="200"
                src="assets/images/cloud4log_log.png"
                alt="cloud4log" />
        </div>

        <div class="tw-flex tw-space-x-2">
            <img
                width="60"
                src="assets/images/GS1-Germany-Logo.svg"
                alt="GS1 Germany" />
            <img
                width="60"
                src="assets/images/BVL123_RZ_Logo_rgb.png"
                alt="BVL" />
        </div>
    </div>

    <div
        class="tw-flex tw-h-20 tw-flex-col tw-items-center tw-justify-center tw-bg-primaryBlue tw-text-center tw-text-3xl tw-font-semibold tw-text-white tw-shadow-xl tw-backdrop-blur">
        <div>{{ 'LANDING.HEADING-1' | translate }}</div>
        <div class="tw-text-xl tw-font-thin">
            {{ 'LANDING.HEADING-2' | translate }}
        </div>
    </div>

    <!-- Announcements -->
    @if (announcements()?.length) {
        <div class="tw-flex tw-w-full tw-justify-center tw-px-6 lg:tw-px-60">
            <div
                class="announcement-bar tw-relative tw-mt-5 tw-rounded-md tw-shadow-md tw-w-full">
                <mat-icon
                    fontSet="material-symbols-outlined"
                    class="tw-text-primaryOrange notification-shake tw-absolute -tw-top-1 -tw-left-5 tw-text-[42px] tw-w-[42px] tw-h-[42px]"
                    style="
                        font-variation-settings: 'FILL' 1;
                        -webkit-text-stroke: 1px rgba(0, 0, 0, 0.4);
                    "
                    >notifications_active</mat-icon
                >
                <div
                    class="tw-py-2.5 tw-pl-6 tw-pr-4 tw-flex tw-items-start tw-gap-6 tw-w-full">
                    <div
                        class="tw-grid tw-grid-cols-12 tw-gap-2 tw-overflow-y-auto tw-max-h-[136px] tw-justify-center tw-w-full">
                        @for (
                            announcement of announcements();
                            track announcement.identity
                        ) {
                            <div
                                class="tw-col-span-12 announcement-item tw-flex tw-items-start tw-rounded-lg tw-py-2.5 tw-px-3">
                                @if (announcement.source === 'addons') {
                                    <span
                                        style="color: rgb(226, 0, 116)"
                                        class="tw-mr-2"
                                        [matTooltip]="
                                            'USER-PROFILE.ADDONS-ANNOUNCEMENT-TOOLTIP'
                                                | translate
                                        "
                                        >⬤</span
                                    >
                                }
                                <div class="tw-flex tw-flex-col tw-min-w-0">
                                    <span
                                        class="announcement-title tw-text-sm tw-font-bold"
                                        >{{ announcement.title }}</span
                                    >
                                    <span
                                        class="announcement-content tw-text-sm tw-break-words tw-leading-relaxed"
                                        >{{ announcement.content }}</span
                                    >
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    }

    <div
        class="-tw-mt-[37px] tw-flex tw-h-full tw-items-center tw-justify-center tw-overflow-y-auto md:tw-justify-start md:tw-pl-20">
        <div class="tw-flex tw-w-96 tw-flex-col">
            <div
                class="tw-flex tw-w-full tw-flex-col tw-items-center tw-bg-primaryBlue tw-pt-10 tw-pb-7 tw-text-white tw-shadow-xl tw-backdrop-blur">
                <!-- Keycloak Login Button -->
                <div class="tw-w-80 tw-text-center">
                    <button
                        type="button"
                        mat-raised-button
                        aria-label="button-keycloak-login"
                        class="tw-w-full tw-mb-4"
                        color="primary"
                        [disabled]="isLoading()"
                        [ngClass]="{ spinner: isLoading() }"
                        (click)="loginWithKeycloak()">
                        <mat-icon
                            fontSet="material-symbols-outlined"
                            class="tw-mr-2"
                            >login</mat-icon
                        >
                        {{ 'LOGIN.KEYCLOAK-LOGIN-BUTTON' | translate }}
                    </button>

                    <div class="tw-text-sm tw-text-white/80 tw-mb-4">
                        {{ 'LOGIN.KEYCLOAK-LOGIN-DESCRIPTION' | translate }}
                    </div>
                </div>
            </div>

            <div
                class="tw-flex tw-w-full tw-flex-col tw-items-center tw-bg-blue-100 tw-py-8 tw-text-primaryBlue">
                <div class="tw-px-4 tw-text-center">
                    <span class="tw-font-semibold">{{
                        'LANDING.PRODUCT-NAME' | translate
                    }}</span>
                    -
                    {{ 'LANDING.LABEL-1' | translate }}
                </div>

                <div class="tw-mt-6 tw-text-center">
                    <div class="tw-text-xl tw-font-semibold">
                        {{ 'LANDING.LABEL-2' | translate }}
                    </div>
                </div>

                <button
                    mat-flat-button
                    class="tw-my-5 tw-hidden tw-bg-primaryBlue tw-px-12 tw-text-white">
                    {{ 'LANDING.REGISTER-BUTTON' | translate }}
                </button>

                <div class="tw-flex tw-flex-col tw-items-center">
                    <a
                        class="!tw-text-primaryBlue"
                        target="_blank"
                        href="http://www.cloud4log.de"
                        >{{ 'LANDING.MORE-LINK' | translate }}
                    </a>
                    <a
                        class="!tw-text-primaryBlue"
                        target="_blank"
                        href="mailto:c4l-support@t-systems.com?subject={{
                            'LANDING.SUPPORT.SUBJECT' | translate
                        }}"
                        >{{ 'LANDING.SUPPORT.TITLE' | translate }}
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div
        class="tw-pointer-events-none tw-absolute tw-bottom-0 tw-right-0 tw-mx-8 tw-my-14 tw-hidden tw-w-52 tw-flex-col tw-items-start md:tw-flex">
        <img
            class="-tw-ml-3 tw-h-[32px]"
            src="assets/images/TSY_Slogan_Basic_3c_n.svg"
            alt="T-Systems" />

        <div class="tw-text-white">
            {{ 'LANDING.LABEL-3' | translate }}
        </div>

        <div class="gradientbg"></div>
    </div>
    <app-unauth-footer page="login"></app-unauth-footer>
</div>
